/** @jsx jsx */
import { jsx } from '@emotion/core';
import style from './cartButtonStyle';
import { SiteLink } from '../../components';
import { useStore } from '../../store';
import { MdShoppingCart } from 'react-icons/md';

export function CartButton({ scrolled }) {
  const { state } = useStore();
  const count = state.cartInfo || 0;
  const label = count > 0 ? `Cart, ${count} item${count > 1 ? 's' : ''}` : 'Cart';

  return (
    <SiteLink to="/cart" css={[style.button, scrolled && style.buttonScrolled]} aria-label={label} title="Cart">
      <MdShoppingCart />
      {count > 0 && <span css={style.count}>{count > 99 ? '99+' : count}</span>}
    </SiteLink>
  );
}
